
const LastName = ({ elements, lName, placeholder, setLName }) => {
    return elements.lName && <><input value={lName} type="text" id="lname" name="lname" placeholder={placeholder?.lName} onChange={(e) => setLName(e.target.value)} /> </>
}
export default LastName;